/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getInbox, clearInbox } = actions;

export default (filters, beta, ...dependencies) => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      dispatch(getInbox(sessionId, filters, beta));
    } else {
      dispatch(clearInbox());
    }
  }, [authReducer.isLogin, ...dependencies]);
};
